// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"styles_bottomBar__sKcA9"};